export default "__VITE_ASSET__j7qmV9tM__"